const SELECTORS = {
  swiperContainer: '.js-blog-posts-slider',
  blogPostsWrapper: '.blog-posts-slider-wrapper',
};
/**
 * Initialize swiper
 *
 * @param {object} Swiper swiper class object
 * @param {object} Navigation swiper navigation module
 * @param {boolean} isDesktop window width detection
 */
const initBlogPostsSlider = (Swiper, Navigation, isDesktop) => {
  const swiperContainer = document.querySelector(SELECTORS.swiperContainer);
  const swiperOptions = {
    modules: [Navigation],
    slidesPerView: 'auto',
    spaceBetween: 10,
    loop: false,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    breakpoints: {
      640: {
        slidesPerView: 'auto',
        spaceBetween: 20,
      },
      1200: {
        slidesPerView: 'auto',
        spaceBetween: 15,
      },
    },
  };
  if (swiperContainer) {
    const swiper = new Swiper(swiperContainer, swiperOptions);
    const sliderClassList = swiperContainer.closest(SELECTORS.blogPostsWrapper).classList;

    if (isDesktop) {
      swiper.on('slideNextTransitionStart', () => {
        const { isEnd } = swiper;
        sliderClassList.toggle('swiper-end', isEnd);
        sliderClassList.toggle('swipe-to-end', !isEnd);
        sliderClassList.remove('swipe-to-start');
        sliderClassList.toggle('swiper-start', !isEnd);
      });

      swiper.on('slidePrevTransitionStart', () => {
        const { isBeginning } = swiper;
        sliderClassList.toggle('swiper-start', isBeginning);
        sliderClassList.toggle('swipe-to-start', !isBeginning);
        sliderClassList.remove('swipe-to-end');
        sliderClassList.remove('swiper-end');
      });
    } else {
      swiper.off('slideNextTransitionStart');
      swiper.off('slidePrevTransitionStart');
      sliderClassList.remove('swiper-start');
      sliderClassList.remove('swiper-end');
    }
  }
};
document.addEventListener('DOMContentLoaded', () => {
  window.LoadSwiper.then((module) => {
    window.addEventListener('resize', () => {
      initBlogPostsSlider(module.Swiper, module.Navigation, window.innerWidth > 1200);
    });

    initBlogPostsSlider(module.Swiper, module.Navigation, window.innerWidth > 1200);
  });
});
